<template>
  <v-container>
    <getting-data-overlay :is_loading="is_loading"
                          :loading_display_title="$vuetify.lang.t('$vuetify.project_documentation.documentation_list.getting_data_title')"></getting-data-overlay>
    <v-row v-if="!is_loading && !has_loading_error">
      <v-col v-if="documents.length > 0" cols="12">
        <template v-for="(document, index) in documents">
          <v-btn v-if="isVerifiedLink(document.url)"  transition="fade-transition" class="h-50" block color="primary" :key="'document_'+index" @click="openDocumentUrl(document.url)">
            {{ document.display_name }}
          </v-btn>
        </template>
      </v-col>
      <v-col v-else>
        <p>{{ $vuetify.lang.t('$vuetify.project_documentation.documentation_list.no_documentation_found') }}</p>
      </v-col>
    </v-row>
    <v-row v-if="has_loading_error">
      <v-col cols="12">
        <v-col cols="12" class="subtitle-1 text-center">
          {{ $vuetify.lang.t('$vuetify.project_documentation.documentation_list.errors.could_not_load_documentation') }}
        </v-col>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import GettingDataOverlayComponent from "../global/gettingDataOverlayComponent/GettingDataOverlayComponent";
import resourcesApi from "../../../api/resources/resourcesApi";
import store from "@/store";
import appSettings from "../../../mixins/config/appSettings";

export default {
  name: "ProjectDocumentationListComponent",
  data: () => {
    return {
      is_loading: false,
      has_loading_error: false,
      documents: []
    }
  },
  mixins: [appSettings],
  components: {
    gettingDataOverlay: GettingDataOverlayComponent
  },
  methods: {
    //CHECK IF THE URL COMES FROM THE CORRECT BACKEND -> NO CROSS LINKING ALLOWED
    isVerifiedLink($url){
      if($url.startsWith(appSettings.data().appSettings.PLATFORM_BACKEND_BASE_URL)){
        return true
      }
      return false
    },
    //OPEN DOCUMENTATION IN USER'S BROWSER OUTSIDE OF THE APP.
    openDocumentUrl($url){
      window.open($url,'_blank');
    },
    //LOAD THE DOCUMENTATION LIST FROM THE SERVER
    async getProjectDocumentsList(){
      this.is_loading = true;
      var projectId = null;
      let ws = await store.getters.getActiveWorkSession;

      if(ws && (ws.project_settings != null &&  (ws.project_settings.project_id != undefined && ws.project_settings.project_id != null))){
        projectId = ws.project_settings.project_id
      }

      if(projectId == null){
        this.is_loading = false;
        this.has_loading_error = true;
      }

      resourcesApi.getDocumentsListForProject(projectId).then((response) => {
        this.is_loading = false;
        this.documents = response.data;
      }).catch((error)=> {
        this.is_loading = false;
        this.has_loading_error = true;
        window.console.error(error);
      })
    }
  },
  async mounted(){
    if(!this.$workSessions.loading && !this.hasForceCloseWorkSessionFlag){
      await this.$workSessions.performSessionCheck();
    }
    if(this.$auth.isAuthenticated){
      this.getProjectDocumentsList();
    }

  }
}
</script>

<style scoped>

</style>